import { render } from "./userGameRolling.vue?vue&type=template&id=7fd2f964&scoped=true"
import script from "./userGameRolling.vue?vue&type=script&lang=js"
export * from "./userGameRolling.vue?vue&type=script&lang=js"

import "./userGameRolling.vue?vue&type=style&index=0&id=7fd2f964&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd2f964"]])

export default __exports__